<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <h4>{{ thisReport.reportName }}</h4>
        <Toolbar class="p-mb-4">
          <template slot="left">
            <span class="p-input-icon-left">
              <div class="p-inputgroup">
                <Button
                  icon="pi pi-fw pi-refresh"
                  class="p-mr-1"
                  @click="setupComponentData(1, 1)"
                />
                <InputText
                  v-model="searchText"
                  placeholder="Global Search"
                  @input="updateSearch"
                />
                <Button
                  icon="pi pi-times p-pr-1"
                  class="p-mr-1"
                  @click="closeSearch"
                />
                <div
                  :class="getClassForQuickFiltersDiv()"
                  :key="quickFiltersDivKey"
                >
                  <Button
                    style="width: 50px; top: 50%; transform: translate(0%, -50%);"
                    @click="
                      quickFilterDialog = true;
                      quickFilterDialogKey++;
                    "
                    icon="pi pi-filter"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                    :badge="getBadgeForQuickFilters().toString()"
                  />
                  <Button
                    v-if="isEmpty()"
                    @click="clearQuickFilter()"
                    icon="pi pi-times"
                    :class="
                      'p-button-rounded ' + getClassForQuickFiltersButon()
                    "
                  />
                </div>
              </div>
            </span>
          </template>
          <template slot="right">
            <div
              style="width: 185px; display: flex; justify-content: flex-end;"
            >
              <ProgressSpinner
                v-if="makingExport"
                style="width:100%; height:25px;"
                strokeWidth="5"
                fill="#EEEEEE"
                animationDuration=".5s"
              />
              <Button
                v-else
                label="Export all data to excel"
                icon="pi pi-external-link"
                @click="exportData"
              />
            </div>
          </template>
        </Toolbar>
      </div>
    </div>

    <Dialog
      :key="quickFilterDialogKey"
      :visible.sync="quickFilterDialog"
      :style="{ width: '500px', overflowY: 'auto' }"
      header="Quick Filters"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col-2 p-d-flex">
          <strong>Labels</strong>
        </div>
        <div class="p-field p-col-5 p-d-flex">
          <strong>Group By</strong>
        </div>
        <div class="p-field p-col-5 p-d-flex">
          <strong>Values</strong>
        </div>
      </div>
      <div v-for="(element, index) in dbViewFieldsForQuickFilters" :key="index">
        <div v-if="element.filterDropdown === true" class="p-formgrid p-grid">
          <div class="p-field p-col p-d-flex">
            <label class="p-as-center" :for="element.colName">
              {{ element.colName }}
            </label>
          </div>
          <div class="p-field p-col p-d-flex">
            <div v-if="element.canGroup">
              <Checkbox v-model="groups[index]" :binary="true" />
            </div>
          </div>
          <div class="p-field p-col">
            <!-- <div v-if="isQuickFilterable(index)"> -->
            <div v-if="getFieldType(index) === 'Date'" style="width: 250px;">
              <Dropdown
                :showClear="true"
                v-model="quickFiltersSelection[index]"
                :options="getOptions(index)"
                optionLabel="dateModifierName"
                dataKey="id"
                placeholder="Select from the dropdown"
                style="width: 100%"
              />
              <div class="pt-1">
                <InputMask
                  v-if="showDateRanges(index)"
                  mask="99/99/9999"
                  v-model="datesFrom[index]"
                  slotChar="dd/mm/yyyy"
                  placeholder="Date from"
                  style="width: 49%;"
                />
                <InputMask
                  v-if="showDateRanges(index)"
                  mask="99/99/9999"
                  v-model="datesTo[index]"
                  slotChar="dd/mm/yyyy"
                  placeholder="Date to"
                  style="width: 49%; float: right;"
                />
              </div>
            </div>
            <div
              v-else-if="getFieldType(index) === 'Currency'"
              style="width: 250px;"
            >
              £
              <InputNumber
                v-model="datesFrom[index]"
                placeholder="From"
                style="width: 45%;"
              />
              £
              <InputNumber
                v-model="datesTo[index]"
                placeholder="To"
                style="width: 45%; float: right;"
              />
            </div>
            <div
              v-else-if="getFieldType(index) === 'Number'"
              style="width: 250px;"
            >
              <InputNumber
                v-model="datesFrom[index]"
                placeholder="From"
                style="width: 49%;"
              />
              <InputNumber
                v-model="datesTo[index]"
                placeholder="To"
                style="width: 49%; float: right;"
              />
            </div>
            <div v-else style="width: 250px">
              <MultiSelect
                v-if="useAutoComplete(index)"
                filter
                v-model="quickFiltersSelection[index]"
                :options="getOptions(index)"
                :optionLabel="getOptionLabel(element)"
                :dataKey="getDataKey(element)"
                placeholder="Type to display options"
                style="width: 100%"
              />
              <MultiSelect
                v-else
                v-model="quickFiltersSelection[index]"
                :options="getOptions(index)"
                :optionLabel="getOptionLabel(element)"
                :dataKey="getDataKey(element)"
                placeholder="Select from the dropdown"
                style="width: 100%"
              />
            </div>
            <!-- <div
                v-if="getFieldType(index) === 'String'" 
                style="width: 250px;"
              >
                <InputText
                  v-model="quickFiltersSelection[index]"
                />
              </div> -->
            <!-- </div>
            <ProgressSpinner 
              v-else
              style="width:30px; height:30px" 
              strokeWidth="2" 
              fill="#EEEEEE" 
              animationDuration=".5s"
            /> -->
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          style="float: left;"
          label="Clear All Filters"
          icon="pi pi-times"
          class="p-button-danger"
          @click="clearQuickFilter()"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-info"
          style="width: 100px;"
          @click="quickFilterDialog = false"
        />
        <Button
          label="Apply Filters"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 130px;"
          @click="setupQuickFilter()"
        />
      </template>
    </Dialog>

    <ProgressSpinner
      v-if="firstRequesting"
      style="width:50px; height:50px;"
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <div v-else style="width: 100%;">
      <!-- Duplicate reports only: Active/All toggle plus a note on what the tiers mean. -->
      <div
        v-if="isDuplicateReport"
        class="p-mb-2"
        style="display: flex; align-items: center; flex-wrap: wrap;"
      >
        <Checkbox
          v-model="duplicateActiveOnly"
          :binary="true"
          id="duplicateActiveOnly"
        />
        <label for="duplicateActiveOnly" style="margin: 0px 16px 0px 8px;">
          Active records only
        </label>
        <span style="opacity: 0.75;">
          Grouped by cluster. <strong>DUPLICATE</strong> = review to merge.
          <strong>LINKED</strong> = same office or related record, review only.
        </span>
      </div>
      <div v-if="activeGroupsTable">
        <!-- :reports="reports" -->
        <ReportsGroupTable
          :dbViewFields="dbViewFields"
          :groups="groups"
          :colSelectedFieldsForTable="colSelectedFieldsForTable"
          :dbViewFieldsForQuickFilters="dbViewFieldsForQuickFilters"
          :quickFiltersSelection="quickFiltersSelection"
          :datesFrom="datesFrom"
          :datesTo="datesTo"
          :searchText="searchText"
          :reloadData="reloadData"
          :extraFilters="duplicateExtraFilters"
        />
      </div>
      <div v-else style="width: 100%;">
        <component
          :is="tableComponent"
          :reportType="routeId"
          :reportId="thisReport.reportId"
          :colSelectedFieldsForTable="colSelectedFieldsForTable"
          :reports="reports"
          :dbViewFields="dbViewFields"
          :loading="loading"
          :totalRecords="totalRecords"
          :rows="rows"
          :currentPage="currentPage"
          :reloadTable="realoadLazyTable"
          @reload="reload"
          @lazyNext="lazyNext"
          @sortChange="sortChange"
          @colsUpdated="colsUpdated"
          :reportIndexForStore="reportIndexForStore"
        />
      </div>

      <div class="flex justify_space_between my-1">
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/money';
import ReportsService from "@/service/ReportsService";
import FiltersService from "@/service/FiltersSerice";
// import SettingService from "@/service/SettingService"

import ReportsTableWithLazyLoading from "../universalComponents/Reports/ReportsTableWithLazyLoading";
import ReportsGroupTable from "../universalComponents/Reports/ReportsGroupTable";
import RoleService from "@/service/RoleService";

import {
  seedFromQuery,
  queryNamesAnyFilter,
  matchSeededSelection
} from "./reportsQuerySeed";

import moment from "moment";

export default {
  components: {
    ReportsTableWithLazyLoading,
    ReportsGroupTable
  },
  async created() {
    // await this.getActivePermissions()
    // await this.settingService.getAllActiveBranches()
    this.setupComponent();
  },
  data: () => ({
    // settingService: new SettingService(),
    reportsService: new ReportsService(),
    filtersService: new FiltersService(),
    roleService: new RoleService(),

    onlyUserBranch: false,

    reportIndexForStore: null,
    currentReportPermissionCode: null,

    // Duplicate reports only: restricts the SQL functions to active records.
    duplicateActiveOnly: false,
    thisReport: {},
    reports: [], // For whole data set
    dictPer: {
      "Report-SingleCustomer": 5, // permissionCode: index of branch
      "Report-EnquiriesRaised": 6,
      "Report-EnquiriesByCustomer": 5,
      "Report-EnquiriesNotBookedIn": 4,
      "Report-LostOrders": 4,
      "Report-OutstandingOrders": 4,
      "Report-QuoteStatsBranch": 16,
      "Report-QuoteStatsSalesExec": 16,
      "Report-SalesExecSalesStats": 4,
      "Report-UserSystemActivity": 4,
      "Report-OutstandingOrdersDetails": 4,
      "Report-WonOrders": 4
    },
    dbViewFields: [],
    dbViewFieldsForQuickFilters: [],
    quickFiltersSelection: [],
    datesFrom: [],
    datesTo: [],
    groups: [],
    lastGroupedOn: null,
    quickFiltersOptions: [],
    tableKey1: 0,
    disabledArr: [],

    colSelectedFieldsForTable: [],
    requesting: false,

    quickFilterDialogKey1: 0,
    quickFilterDialog: false,

    quickFiltersDivKey1: 0,

    searchText: "",
    totalRecords: null,
    totalPages: null,
    currentPage: 1,
    rows: 25,
    sortField: "",
    sortFieldId: 0,
    sortOrder: 0,
    lastMainRequest: "",
    lastMainRequestBody: "",
    firstRequesting: true,
    forceReload: false,

    makingExport: false,
    activeGroupsTable: false,

    reloadData: 0,
    newlyCreatedComponent: true,

    // A dashboard drill arrives with its filters in the route query (item 4, decision 6).
    // They are seeded into the quick filters before the first fetch, so the total on screen
    // is the figure on the widget that was clicked rather than an unfiltered one corrected a
    // moment later. This holds the route that was seeded, not a boolean: one report drilling
    // to another reuses this component (same route name, different params), so a flag would
    // leave the second report unfiltered. Keyed by route, a filter the user changes by hand
    // while they stay on that route is still not undone.
    querySeedApplied: null
  }),
  computed: {
    myPermissions() {
      return this.$store.getters["auth/getUserPermissions"];
    },
    routeId() {
      return this.$route.params.id;
    },
    allReports() {
      return this.$store.getters["reports/getAllReports"];
    },
    hardLoad() {
      return this.$store.getters["reports/getHardLoad"][
        this.reportIndexForStore
      ];
    },
    softReload() {
      return this.$store.getters["reports/getSoftReload"][
        this.reportIndexForStore
      ];
    },
    realoadLazyTable: {
      set() {
        this.tableKey1++;
      },
      get() {
        return "realoadLazyTable-" + this.tableKey1.toString();
      }
    },
    loading() {
      //
      if (this.reports && this.reports[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    quickFilterDialogKey: {
      set() {
        this.quickFilterDialogKey1++;
      },
      get() {
        return "quickFilterDialogKey-" + this.quickFilterDialogKey1.toString();
      }
    },
    tableComponent() {
      return this.firstRequesting === false
        ? ReportsTableWithLazyLoading
        : null;
    },
    isDuplicateReport() {
      return (
        this.currentReportPermissionCode === "Report-DuplicateCustomers" ||
        this.currentReportPermissionCode === "Report-DuplicateEnquiries"
      );
    },
    // Passed to ReportsGroupTable, which builds its own request body.
    duplicateExtraFilters() {
      return this.isDuplicateReport
        ? { activeOnly: this.duplicateActiveOnly }
        : {};
    },
    quickFiltersDivKey: {
      set(val) {
        this.quickFiltersDivKey1++;
      },
      get() {
        return "quickFiltersDivKey" + this.quickFiltersDivKey1.toString();
      }
    }
  },
  watch: {
    quickFiltersSelection: {
      handler(newValue) {
        this.$store.dispatch("reports/setMainListQuickFilters", {
          list: newValue,
          id: this.reportIndexForStore
        });
      },
      deep: true
    },
    duplicateActiveOnly() {
      // The grouped table refetches itself through its extraFilters watcher.
      if (!this.activeGroupsTable) {
        this.forceReload = true;
        this.getDataFromSource();
      }
    },
    routeId(val) {
      this.activeGroupsTable = false;
      this.setupComponent();
    },
    allReports(val) {
      this.setupComponent();
    },
    currentPage(val) {
      //
      this.$store.dispatch("reports/setPage", {
        page: val,
        rows: this.$store.getters["reports/getRows"][this.reportIndexForStore],
        id: this.reportIndexForStore
      });

      if (val === 1) {
        this.realoadLazyTable++;
      }
    },
    hardLoad(val) {
      this.setupComponentData(1, 2);
    },
    softReload(val) {
      this.setupComponentData(0, 3);
    },
    colSelectedFieldsForTable(val) {
      this.realoadLazyTable++;
    },
    dbViewFieldsForQuickFilters(val) {
      if (!this.quickFiltersSelection.every(element => !element)) {
        this.getDataFromSource();
      }
    },
    dbViewFields(val) {
      this.setupViewFieldsForQuickFilters();
      this.setupColumns();
    },
    datesFrom(val) {
      this.$store.dispatch("reports/setQuickFiltersDatesFrom", {
        list: val,
        id: this.reportIndexForStore
      });
    },
    datesTo(val) {
      this.$store.dispatch("reports/setQuickFiltersDatesTo", {
        list: val,
        id: this.reportIndexForStore
      });
    },
    groups(val) {
      //
      let trues = 0,
        trueLocation = null,
        modifiedArr = val,
        newIndex = null;
      val.forEach((a, index) => {
        if (a) {
          trues++;
          trueLocation = index;
        }
      });
      if (trues > 1) {
        val.forEach((a, index) => {
          if (a === true && index === this.lastGroupedOn) {
            modifiedArr[index] = false;
          } else if (a === true && index !== this.lastGroupedOn) {
            newIndex = index;
          }
        });
      } else if (trues === 1) {
        newIndex = trueLocation;
      }
      this.lastGroupedOn = newIndex;

      this.$store.dispatch("reports/setQuickFiltersGroups", {
        list: val,
        id: this.reportIndexForStore
      });
    }
  },
  methods: {
    colsUpdated(cols) {
      this.$store.dispatch("reports/setColumns", {
        list: cols,
        id: this.reportIndexForStore
      });
    },
    setupComponent() {
      if (this.allReports && this.allReports[0]) {
        const matchedReport = this.allReports.find(
          a => a.reportName === this.routeId
        );
        const previousIndex = this.reportIndexForStore;
        if (matchedReport) {
          this.reportIndexForStore = this.allReports.indexOf(matchedReport);
          this.currentReportPermissionCode = matchedReport.permissionCode;
        }
        // A different report in the same screen - which only happens since a report cell can
        // drill to another report (item 4, task 2.3). The quick filters are held per column
        // index, so the previous report's must not be left standing against the new report's
        // columns: they would be read as filters that report never had.
        if (previousIndex !== null && previousIndex !== this.reportIndexForStore) {
          this.quickFiltersSelection = [];
          this.datesFrom = [];
          this.datesTo = [];
          this.groups = [];
          this.dbViewFields = [];
          this.dbViewFieldsForQuickFilters = [];
          this.quickFiltersOptions = [];
          this.lastMainRequest = "";
          this.lastMainRequestBody = "";
          this.searchText = "";
        }
        this.thisReport = this.allReports[this.reportIndexForStore];

        if (this.thisReport && this.thisReport.id && this.thisReport.reportEP) {
          this.firstRequesting = true;

          // setTimeout(() => {
          //
          //   if (!this.forceReload) {
          let a = this.$store.getters["reports/getFirstTimeLoad"][
            this.reportIndexForStore
          ];

          if (a) {
            this.$store.dispatch("reports/setFirstTimeLoad", {
              bool: false,
              id: this.reportIndexForStore
            });
            this.setupComponentData(1, 4);
          } else {
            this.setupComponentData(0, 5);
          }
          //   }
          // }, 50)
          this.setupDBViewFields();
        }
      }
    },
    setupComponentData(hardLoad, calling) {
      if (
        this.$store.getters["reports/getColumns"] &&
        this.$store.getters["reports/getColumns"][0]
      ) {
        if (hardLoad) {
          this.forceReload = true;
          // The reset below clears the quick filters. A drill's filters live in the URL, which
          // still says them, so let the seed run again rather than landing unfiltered. TEST
          // 2026-09-17: without this, drilling to a report you had already opened this session
          // arrived on 45,504 rows instead of 2,534 - the seed ran, then this reset wiped it.
          this.querySeedApplied = null;

          // setup sort

          this.sortField = "";
          this.sortFieldId = 0;
          this.sortOrder = 0;
          this.$store.dispatch("reports/setSort", {
            sortField: this.sortField,
            sortFieldId: this.sortFieldId,
            sortOrder: this.sortOrder,
            id: this.reportIndexForStore
          });

          // setup page and rows

          this.rows = 25;
          this.currentPage = 1;
          this.$store.dispatch("reports/setPage", {
            page: this.currentPage,
            rows: this.rows,
            id: this.reportIndexForStore
          });

          this.realoadLazyTable++;

          // setup search

          this.searchText = "";

          // setup quick filters

          this.quickFiltersSelection = [];
          this.datesFrom = [];
          this.datesTo = [];
          this.groups = [];
          this.$store.dispatch("reports/setMainListQuickFilters", {
            list: this.quickFiltersSelection,
            id: this.reportIndexForStore
          });
          this.$store.dispatch("reports/setQuickFiltersDatesFrom", {
            list: this.datesFrom,
            id: this.reportIndexForStore
          });
          this.$store.dispatch("reports/setQuickFiltersDatesTo", {
            list: this.datesTo,
            id: this.reportIndexForStore
          });
          this.$store.dispatch("reports/setQuickFiltersGroups", {
            list: this.groups,
            id: this.reportIndexForStore
          });
        } else {
          // setup sort

          if (
            this.$store.getters["reports/getSortField"][
              this.reportIndexForStore
            ]
          ) {
            this.sortField = this.$store.getters["reports/getSortField"][
              this.reportIndexForStore
            ];
            this.sortFieldId = this.$store.getters["reports/getSortFieldId"][
              this.reportIndexForStore
            ];
            this.sortOrder = this.$store.getters["reports/getSortOrder"][
              this.reportIndexForStore
            ];
          }

          // setup page and rows

          this.rows = this.$store.getters["reports/getRows"][
            this.reportIndexForStore
          ];
          this.currentPage = this.$store.getters["reports/getPage"][
            this.reportIndexForStore
          ];

          // setup search

          this.$route.query.search
            ? (this.searchText = this.$route.query.search)
            : (this.searchText = "");

          // setup quick filters

          this.quickFiltersSelection = [
            ...this.$store.getters["reports/getMainListQuickFilter"]
          ][this.reportIndexForStore];
          this.datesFrom = [
            ...this.$store.getters["reports/getQuickFiltersDatesFrom"][
              this.reportIndexForStore
            ]
          ];
          this.datesTo = [
            ...this.$store.getters["reports/getQuickFiltersDatesTo"][
              this.reportIndexForStore
            ]
          ];
          this.groups = [
            ...this.$store.getters["reports/getQuickFiltersGroups"][
              this.reportIndexForStore
            ]
          ];
        }
        // A drill's filters are only known once the report's columns are, because they are held
        // per column index. With the columns in hand, seed now and let applyQuerySeed make the
        // request; without them, leave it to setupViewFieldsForQuickFilters, which runs when
        // they arrive. Either way nothing unfiltered goes out first.
        if (this.querySeedPending()) {
          if (this.dbViewFieldsForQuickFilters.length) {
            this.applyQuerySeed();
          }
          return;
        }
        this.getDataFromSource();
      }
    },
    // True while the route query names something and the seed has not run yet. Deliberately
    // cheap - the columns may not have loaded - and safe: the seed path fetches either way.
    querySeedPending() {
      if (this.querySeedApplied === this.querySeedKey()) return false;
      const query = this.$route.query || {};
      return Object.keys(query).some(
        key =>
          key !== "search" &&
          query[key] !== null &&
          query[key] !== undefined &&
          String(query[key]).trim() !== ""
      );
    },
    // Which route the seed belongs to: the report, and the filters asked of it. One report
    // drilling to another reuses this component, so the seed is remembered per route.
    querySeedKey() {
      return JSON.stringify([this.routeId, this.$route.query || {}]);
    },
    // Writes a drill's filters into the quick filters, then fetches. Called once the report's
    // columns are known; the Vuex mirrors happen through the existing watchers.
    applyQuerySeed() {
      const columns = this.dbViewFieldsForQuickFilters;
      if (
        this.querySeedApplied !== this.querySeedKey() &&
        columns.length &&
        queryNamesAnyFilter(this.$route.query, columns)
      ) {
        const seed = seedFromQuery(this.$route.query, columns);
        if (seed.seeded) {
          this.querySeedApplied = this.querySeedKey();
          this.quickFiltersSelection = seed.selection;
          this.datesFrom = seed.datesFrom;
          this.datesTo = seed.datesTo;

          if (seed.sortFieldId) {
            this.sortField = seed.sortField;
            this.sortFieldId = seed.sortFieldId;
            this.sortOrder = seed.sortOrder;
            this.$store.dispatch("reports/setSort", {
              sortField: this.sortField,
              sortFieldId: this.sortFieldId,
              sortOrder: this.sortOrder,
              id: this.reportIndexForStore
            });
            this.realoadLazyTable++;
          }
        }
      }
      this.getDataFromSource();
    },
    getDataFromSource() {
      let quickFilters = {};

      var cancelRequest = false;

      if (
        !(
          this.quickFiltersSelection.every(element => !element) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].filterDropdown) {
                let a = this.dbViewFieldsForQuickFilters[i].colField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].colField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (this.dbViewFieldsForQuickFilters[i].colType === "Date") {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }
                      if (this.datesTo[i]) {
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      //
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0) {
                          if (this.dbViewFieldsForQuickFilters[i].filterFldId) {
                            quickFilters[a] = this.quickFiltersSelection[i]
                              .map(item => {
                                return item[
                                  this.dbViewFieldsForQuickFilters[i]
                                    .filterFldId
                                ];
                              })
                              .join(",");
                          } else {
                            quickFilters[a] = this.quickFiltersSelection[i]
                              .map(item => {
                                return item[
                                  this.dbViewFieldsForQuickFilters[i].colField
                                ];
                              })
                              .join(",");
                          }
                        }
                      }
                    }
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].colType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].colType === "Number"
                  ) {
                    //
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        } else {
          cancelRequest = true;
        }
      }
      if (this.currentReportPermissionCode) {
        let permission = this.myPermissions.find(
          a => a.permission.permissionCode === this.currentReportPermissionCode
        );
        if (permission) {
          if (permission.permissionLevel == 5) {
            var branch = this.$store.getters["auth/getMyProfile"].defBranch;
            if (!branch) {
              this.noBranchHandle();
              return;
            }
            quickFilters["mbpBranchCode"] = branch.id;
          }
        }
      }

      if (this.isDuplicateReport) {
        quickFilters["activeOnly"] = this.duplicateActiveOnly;
      }

      var thisMainRequestBody = JSON.stringify(quickFilters);

      let searchQuery = "*";
      if (this.searchText) {
        searchQuery = this.searchText;
      }

      var thisRequest = `${this.routeId}/${this.currentPage}/${this.rows}/${this.sortFieldId}/${this.sortOrder}/${searchQuery}`;

      if (!cancelRequest) {
        if (
          !(
            thisRequest === this.lastMainRequest &&
            thisMainRequestBody === this.lastMainRequestBody
          ) ||
          (this.forceReload && !this.newlyCreatedComponent)
        ) {
          this.forceReload = false;

          this.lastMainRequest = thisRequest;
          this.lastMainRequestBody = thisMainRequestBody;

          this.requesting = true;
          this.reports = [];

          this.reportsService
            .getReportData(
              this.thisReport.reportEP,
              this.currentPage,
              this.rows,
              this.sortFieldId,
              this.sortOrder,
              searchQuery,
              quickFilters
            )
            .then(response => {
              let a = response.config.url.split("/"),
                b = a.map(c => parseInt(c));

              if (
                a[6] === "*" &&
                this.searchText === "" &&
                b[2] === this.currentPage &&
                b[3] === this.rows &&
                b[4] === this.sortFieldId &&
                b[5] === this.sortOrder
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.reports = response.data;
                this.setupQuickFilter();
              } else if (
                a[6] === this.searchText &&
                b[2] === this.currentPage &&
                b[3] === this.rows &&
                b[4] === this.sortFieldId &&
                b[5] === this.sortOrder
              ) {
                this.requesting = false;
                this.firstRequesting = false;

                this.totalRecords = parseInt(response.headers.reccount);
                this.reports = response.data;
                this.setupQuickFilter();
              }
            })
            .catch(err => {
              this.requesting = false;

              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content: `Error while getting reports for page ${this.currentPage} and search text ${this.searchText}`
              });
            });
        } else {
          if (this.forceReload && this.newlyCreatedComponent) {
            this.newlyCreatedComponent = false;
            this.forceReload = false;
          }
        }
      }
    },
    sortChange({ sortField, sortFieldId, sortOrder }) {
      this.$store.dispatch("reports/setSort", {
        sortField,
        sortFieldId,
        sortOrder,
        id: this.reportIndexForStore
      });

      this.sortField = sortField;
      this.sortFieldId = sortFieldId;
      this.sortOrder = sortOrder;

      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }

      this.getDataFromSource();
    },
    lazyNext({ page, rows, totalPages }) {
      this.$store.dispatch("reports/setPage", {
        page,
        rows,
        id: this.reportIndexForStore
      });

      this.rows = rows;
      this.totalPages = totalPages;
      if (this.currentPage !== page) {
        this.currentPage = page;
      }

      this.getDataFromSource();
    },
    setupQuickFilter() {
      this.reloadData++;

      this.quickFilterDialog = false;
      this.$store.dispatch("reports/setMainListQuickFilters", {
        list: this.quickFiltersSelection,
        id: this.reportIndexForStore
      });
      this.$store.dispatch("reports/setQuickFiltersDatesFrom", {
        list: this.datesFrom,
        id: this.reportIndexForStore
      });
      this.$store.dispatch("reports/setQuickFiltersDatesTo", {
        list: this.datesTo,
        id: this.reportIndexForStore
      });
      this.$store.dispatch("reports/setQuickFiltersGroups", {
        list: this.groups,
        id: this.reportIndexForStore
      });

      //

      if (!this.groups.every(element => !element)) {
        this.activeGroupsTable = true;
      } else {
        this.activeGroupsTable = false;
        this.getDataFromSource();
      }
    },
    closeSearch() {
      this.searchText = "";
      this.$router.push({ query: { search: "" } });
      this.getDataFromSource();
    },
    updateSearch(e) {
      this.searchText = e;
      this.$router.push({ query: { search: e } });

      if (!this.activeGroupsTable) {
        this.getDataFromSource();
      }
    },
    setupViewFieldsForQuickFilters() {
      this.dbViewFieldsForQuickFilters = [];

      var notExists = this.quickFiltersSelection.every(element => !element),
        groupNotActive = this.groups.every(element => !element);

      this.dbViewFields.forEach((d, index) => {
        this.dbViewFieldsForQuickFilters.push(d);

        // if (d.quickFilter) {

        if (d.colType === "Date") {
          this.filtersService
            .getDateModifiers()
            .then(data => {
              this.quickFiltersOptions[index] = data;
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            })
            .catch(err => {
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "Error while getting date modifiers",
              //   life: 5000,
              // })
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content: 'Some data was not loaded from "dateModifiers"'
              });
            });
        } else if (d.filterEP) {
          //
          if (d.filterEP === "YES/NO") {
            this.quickFiltersOptions[index] = [
              { id: 1, [d.id]: "Yes" },
              { id: 2, [d.id]: "No" }
            ];
            this.checkExistanceOfFilterFldId(
              this.quickFiltersOptions[index],
              index
            );
          } else if (d.filterEP.substr(0, 1) === "*") {
            let list = d.filterEP.substr(1).split("/");
            if (list.length) {
              this.quickFiltersOptions[index] = list.map((a, index) => {
                return { id: index, [d.colField]: a };
              });
              this.checkExistanceOfFilterFldId(
                this.quickFiltersOptions[index],
                index
              );
            }
          } else {
            this.filtersService
              .filtersCustomRequest(d.filterEP)
              .then(data => {
                this.quickFiltersOptions[index] = data;
                this.checkExistanceOfFilterFldId(
                  this.quickFiltersOptions[index],
                  index
                );
              })
              .catch(err => {
                if (err && err.response && err.response.status !== 200) {
                  // this.$toast.add({
                  //   severity: "error",
                  //   summary: "Error",
                  //   detail: "Error while getting quick filters",
                  //   life: 5000,
                  // })
                  this.$store.dispatch("addErrorMessage", {
                    severity: "error",
                    content: `Some data was not loaded from "${d.filterEP}"`
                  });
                }
              });
          }
        }

        // }
        if (notExists) {
          this.quickFiltersSelection.push(null);
        }
        if (groupNotActive) {
          this.groups.push(false);
        }
        this.quickFiltersOptions.push({});
        //
      });

      // The columns are now known, so a drill's filters can be placed against them. Also the
      // first chance to fetch on a cold visit, where setupComponentData ran before the columns
      // had arrived; an identical request is dropped by getDataFromSource, so nothing repeats.
      if (this.querySeedPending() || this.lastMainRequest === "") {
        this.applyQuerySeed();
      }
    },
    checkExistanceOfFilterFldId(quickFilterOptionsList, index) {
      try {
        if (
          !this.quickFiltersSelection[index] ||
          !this.quickFiltersSelection[index] == null
        )
          this.quickFiltersSelection[index] = quickFilterOptionsList.find(
            a =>
              a[this.dbViewFields[index].filterFldId] ===
              this.dbViewFields[index].filterDefId
          );
        else if (this.querySeedApplied === this.querySeedKey()) {
          // A seeded filter arrives as an id, because the options had not loaded yet. Now
          // they have, swap in the real option so the dialog reads "Active" or "Last 24
          // hours" rather than a bare id. The posted value is the same either way.
          this.$set(
            this.quickFiltersSelection,
            index,
            matchSeededSelection(
              this.quickFiltersSelection[index],
              quickFilterOptionsList,
              this.dbViewFields[index]
            )
          );
        }
      } catch (e) {}
    },
    setupColumns() {
      let a = [];
      for (let i = 0; i < this.dbViewFields.length; i++) {
        if (this.dbViewFields[i].canShow === true) a.push(this.dbViewFields[i]);
      }

      if (a.length) {
        this.colSelectedFieldsForTable = a;
      } else {
        this.colSelectedFieldsForTable = [];
      }
    },
    setupDBViewFields() {
      let cols = this.$store.getters["reports/getColumns"][
        this.reportIndexForStore
      ];
      if (cols && cols[0]) {
        this.dbViewFields = cols;
      } else {
        this.getDBReportColumns();
      }
    },
    getDBReportColumns() {
      this.reportsService
        .dbReportColumns(this.thisReport.id)
        .then(data => {
          this.dbViewFields = data;
          this.$store.dispatch("reports/setColumns", {
            list: data,
            id: this.reportIndexForStore
          });
        })
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content:
              'Some data was not loaded from "dbReportColumns/{reportId}"'
          });
        });
    },
    isEmpty() {
      //
      return !(
        this.quickFiltersSelection.every(element => !element) &&
        this.datesFrom.every(element => !element) &&
        this.datesTo.every(element => !element) &&
        this.groups.every(element => !element)
      );
    },
    getBadgeForQuickFilters() {
      //
      let count = 0;
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        if (
          this.quickFiltersSelection[i] ||
          this.datesFrom[i] ||
          this.datesTo[i] ||
          this.groups[i]
        ) {
          if (Array.isArray(this.quickFiltersSelection[i])) {
            if (this.quickFiltersSelection[i].length > 0) count++;
          } else {
            count++;
          }
        }
      }
      //
      return count;
    },
    getClassForQuickFiltersButon() {
      if (this.isEmpty()) {
        return "p-button-success";
      } else {
        return "p-button-info";
      }
    },
    getClassForQuickFiltersDiv() {
      if (this.isEmpty()) {
        return "greenBackground";
      } else {
        return "defaultBackground";
      }
    },
    isQuickFilterable(index) {
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].filterDropdown
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    getFieldType(index) {
      //
      //
      //
      return this.dbViewFieldsForQuickFilters[index] &&
        this.dbViewFieldsForQuickFilters[index].colType
        ? this.dbViewFieldsForQuickFilters[index].colType
        : "";
    },
    setSelection({ value, index }) {
      //
      if (Object.keys(value).length) {
        this.quickFiltersSelection[index] = value;
      } else [(this.quickFiltersSelection[index] = null)];
    },
    useAutoComplete(index) {
      //
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterAutocomplete
        : false;
    },
    showDropdown(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? this.dbViewFieldsForQuickFilters[index].filterDropdown
        : false;
    },
    isForceSelection(index) {
      return this.dbViewFieldsForQuickFilters[index]
        ? !this.dbViewFieldsForQuickFilters[index].filterAllowStartWith
        : false;
    },
    getOptions(index) {
      var branch = this.$store.getters["auth/getMyProfile"].defBranch;
      if (
        this.dictPer[this.currentReportPermissionCode] &&
        this.dictPer[this.currentReportPermissionCode] === index
      ) {
        let permission = this.myPermissions.find(
          a => a.permission.permissionCode === this.currentReportPermissionCode
        );

        if (permission) {
          if (permission.permissionLevel == 5) {
            if (!branch) {
              this.noBranchHandle();
              return;
            }

            if (this.quickFiltersOptions[index].length > 0) {
              this.quickFiltersOptions[index] = this.quickFiltersOptions[
                index
              ].filter(qf => qf.id === branch.id);
            }
            this.quickFiltersSelection[index] = [branch];
            return this.quickFiltersOptions[index];
          }
        }
      }
      return Array.isArray(this.quickFiltersOptions[index])
        ? this.quickFiltersOptions[index]
        : [];
    },
    noBranchHandle() {
      this.$router.push({ name: "dashboard", query: { toast: "yes" } });
    },
    getDataKey(data) {
      return data ? data.filterFldId : null;
    },
    getOptionLabel(data) {
      if (data) {
        return data.filterFldValue || data.colField;
      }
    },
    showDateRanges(index) {
      //
      if (
        this.quickFiltersSelection[index] &&
        this.quickFiltersSelection[index].dateModifierFunc === "custom"
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearQuickFiltersSelections() {
      for (let i = 0; i < this.quickFiltersSelection.length; i++) {
        this.quickFiltersSelection[i] = null;
        this.datesFrom[i] = null;
        this.datesTo[i] = null;
        this.groups[i] = false;
      }
      this.activeGroupsTable = false;
      this.quickFiltersDivKey++;
    },
    clearQuickFilter() {
      this.quickFilterDialog = false;
      this.clearQuickFiltersSelections();
      this.getDataFromSource();
    },
    reload() {
      this.forceReload = true;
      this.setupComponentData(0, 6);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let b = data;

      if (b !== null && b !== undefined) {
        if (col.colType === "Currency") {
          try {
            return formatCurrency(b);
          } catch (e) {
            return b;
          }
        } else if (col.colType === "Number") {
          try {
            let c = b.toString().split(".");
            //

            if (c[0]) {
              let d = c[0].split(",");
              if (d.length < 2) {
                c[0] = this.numberWithCommas(c[0]);
              }
            }

            return `${c[0]}`;
          } catch (e) {
            return b;
          }
        } else {
          return b;
        }
      } else {
        return "";
      }
    },
    async getActivePermissions() {
      try {
        await this.roleService.getActivePermissions();
      } catch (e) {
        this.$store.dispatch("addErrorMessage", {
          severity: "error",
          content: 'Some data was not loaded from "activePermissions}"'
        });
      }
    },
    exportData() {
      var tHeader = [],
        headers = [],
        data = [],
        a = new Date(),
        date = `${a.getDate()}_${a.getMonth() +
          1}_${a.getFullYear()}-${a.getHours()}_${a.getMinutes()}_${a.getSeconds()}`,
        date1 = `${a.getDate()}/${a.getMonth() +
          1}/${a.getFullYear()} ${a.getHours()}:${a.getMinutes()}:${a.getSeconds()}`,
        quickFilters = {};

      this.colSelectedFieldsForTable.forEach((field, index) => {
        headers.push(field.colName);
        if (index < 2) {
          tHeader.push(field.colName);
        } else {
          tHeader.push("");
        }
      });

      if (tHeader[0]) {
        tHeader[0] = "Report Run on:";
      }
      if (tHeader[1]) {
        tHeader[1] = date1;
      }
      data.push([]);
      data.push(["Filters Applied:"]);

      if (
        !(
          this.quickFiltersSelection.every(element => !element) &&
          this.datesFrom.every(
            element => element === undefined || element === null
          ) &&
          this.datesTo.every(
            element => element === undefined || element === null
          )
        )
      ) {
        if (this.dbViewFieldsForQuickFilters.length) {
          for (let i = 0; i < this.dbViewFieldsForQuickFilters.length; i++) {
            try {
              if (this.dbViewFieldsForQuickFilters[i].filterDropdown) {
                //

                let a = this.dbViewFieldsForQuickFilters[i].colField
                  .split(".")
                  .slice(0)[0];
                let b = this.dbViewFieldsForQuickFilters[i].colField
                  .split(".")
                  .slice(-1)[0];

                if (this.quickFiltersSelection[i]) {
                  if (this.dbViewFieldsForQuickFilters[i].colType === "Date") {
                    //

                    if (
                      this.quickFiltersSelection[i].dateModifierFunc ===
                      "custom"
                    ) {
                      //
                      if (this.datesFrom[i]) {
                        data.push([
                          `${this.dbViewFieldsForQuickFilters[i].colName} From`,
                          this.datesFrom[i]
                        ]);
                        try {
                          quickFilters[`${a}From`] = moment(
                            this.datesFrom[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}From`] = this.datesFrom[i];
                        }
                      }

                      if (this.datesTo[i]) {
                        data.push([
                          `${this.dbViewFieldsForQuickFilters[i].colName} To`,
                          this.datesTo[i]
                        ]);
                        try {
                          quickFilters[`${a}To`] = moment(
                            this.datesTo[i],
                            "DD/MM/YYYY"
                          ).format("YYYY/MM/DD");
                        } catch (e) {
                          quickFilters[`${a}To`] = this.datesTo[i];
                        }
                      }
                    } else {
                      data.push([
                        this.dbViewFieldsForQuickFilters[i].colName,
                        this.quickFiltersSelection[i].dateModifierFunc
                      ]);
                      quickFilters[a] = this.quickFiltersSelection[
                        i
                      ].dateModifierFunc;
                    }
                  } else {
                    //
                    if (this.quickFiltersSelection[i][b] === "Yes") {
                      data.push([
                        this.dbViewFieldsForQuickFilters[i].colName,
                        true
                      ]);
                      quickFilters[a] = true;
                    } else if (this.quickFiltersSelection[i][b] === "No") {
                      data.push([
                        this.dbViewFieldsForQuickFilters[i].colName,
                        false
                      ]);
                      quickFilters[a] = false;
                    } else if (
                      this.dbViewFieldsForQuickFilters[i].lovEP &&
                      this.dbViewFieldsForQuickFilters[i].lovEP.substr(0, 1) ===
                        "*"
                    ) {
                      data.push([
                        this.dbViewFieldsForQuickFilters[i].colName,
                        this.quickFiltersSelection[i][b]
                      ]);
                      quickFilters[a] = this.quickFiltersSelection[i][b];
                    } else {
                      //
                      if (typeof this.quickFiltersSelection[i] === "string") {
                        data.push([
                          this.dbViewFieldsForQuickFilters[i].colName,
                          this.quickFiltersSelection[i]
                        ]);
                        quickFilters[a] = this.quickFiltersSelection[i];
                      } else {
                        if (this.quickFiltersSelection[i]?.length > 0) {
                          if (this.dbViewFieldsForQuickFilters[i].filterFldId) {
                            quickFilters[a] = this.quickFiltersSelection[i]
                              .map(item => {
                                return item[
                                  this.dbViewFieldsForQuickFilters[i]
                                    .filterFldId
                                ];
                              })
                              .join(",");
                          } else {
                            quickFilters[a] = this.quickFiltersSelection[i]
                              .map(item => {
                                return item[
                                  this.dbViewFieldsForQuickFilters[i].colField
                                ];
                              })
                              .join(",");
                          }
                        }
                      }
                    }
                  }
                } else if (this.datesFrom[i] || this.datesTo[i]) {
                  if (
                    this.dbViewFieldsForQuickFilters[i].colType ===
                      "Currency" ||
                    this.dbViewFieldsForQuickFilters[i].colType === "Number"
                  ) {
                    //
                    data.push([
                      `${this.dbViewFieldsForQuickFilters[i].colName} From`,
                      this.datesFrom[i]
                    ]);
                    data.push([
                      `${this.dbViewFieldsForQuickFilters[i].colName} To`,
                      this.datesTo[i]
                    ]);
                    quickFilters[`${a}From`] = this.datesFrom[i];
                    quickFilters[`${a}To`] = this.datesTo[i];
                  }
                }
              }
            } catch (e) {
              continue;
            }
          }
        }
      }

      import("@/service/Export2Excel").then(excel => {
        //

        this.makingExport = true;
        this.reportsService
          .getReportData(
            this.thisReport.reportEP,
            1,
            100000,
            0,
            0,
            "*",
            quickFilters
          )
          .then(response => {
            //

            var responseData = response.data,
              totalSums = [];

            if (responseData && responseData.length) {
              //

              if (this.activeGroupsTable) {
                if (this.dbViewFields && this.dbViewFields[0]) {
                  for (let h = 0; h < this.groups.length; h++) {
                    // IT WILL ONLY RUN FOR THE FIRST 'TRUE' VALUE
                    if (this.groups[h]) {
                      let sums = [],
                        types = [],
                        sumsHeaders = [];

                      sums.push([this.dbViewFields[h].colName]);

                      for (
                        let i = 0;
                        i < this.colSelectedFieldsForTable.length;
                        i++
                      ) {
                        if (this.colSelectedFieldsForTable[i].applySum) {
                          sumsHeaders.push(this.colSelectedFieldsForTable[i]);
                          sums[0].push(
                            `Total ${this.colSelectedFieldsForTable[i].colName}`
                          );
                          totalSums.push(0);
                        } else {
                          totalSums.push("");
                        }
                      }
                      sums[0].push(`Total Quotes`);

                      for (let i = 0; i < responseData.length; i++) {
                        //

                        let index = types.findIndex(
                          a =>
                            a === responseData[i][this.dbViewFields[h].colField]
                        );
                        if (index < 0) {
                          types.push(
                            responseData[i][this.dbViewFields[h].colField]
                          );

                          let a = [
                            responseData[i][this.dbViewFields[h].colField]
                          ];
                          for (let j = 1; j < sums[0].length; j++) {
                            a.push(0);
                          }
                          sums.push(a);

                          index =
                            types.findIndex(
                              a =>
                                a ===
                                responseData[i][this.dbViewFields[h].colField]
                            ) + 1;
                        } else {
                          index++;
                        }

                        //

                        for (let j = 1; j < sums[0].length; j++) {
                          if (j === sums[0].length - 1) {
                            // last one is the totals (not in the column)
                            sums[index][j]++;
                          } else {
                            sums[index][j] +=
                              responseData[i][sumsHeaders[j - 1].colField];
                          }
                        }

                        // calculating total sums below
                        for (
                          let j = 0;
                          j < this.colSelectedFieldsForTable.length;
                          j++
                        ) {
                          if (this.colSelectedFieldsForTable[j].applySum) {
                            if (
                              responseData[i][
                                this.colSelectedFieldsForTable[j].colField
                              ]
                            ) {
                              totalSums[j] +=
                                responseData[i][
                                  this.colSelectedFieldsForTable[j].colField
                                ];
                            }
                          }
                        }
                      }

                      if (sums.length) {
                        data.push([]);
                        data.push(sums[0]);
                        for (let i = 1; i < sums.length; i++) {
                          let row = [sums[i][0]];
                          for (let j = 1; j < sums[i].length; j++) {
                            if (j === sums[i].length - 1) {
                              row.push(sums[i][j]);
                            } else {
                              row.push(
                                this.getToShow(sums[i][j], sumsHeaders[j - 1])
                              );
                            }
                          }
                          data.push(row);
                        }
                      }

                      break;
                    }
                  }
                }
              } else {
                for (let i = 0; i < responseData.length; i++) {
                  //

                  // calculating total sums below
                  for (
                    let j = 0;
                    j < this.colSelectedFieldsForTable.length;
                    j++
                  ) {
                    if (this.colSelectedFieldsForTable[j].applySum) {
                      if (i === 0) {
                        totalSums.push(0);
                      }

                      if (
                        responseData[i][
                          this.colSelectedFieldsForTable[j].colField
                        ]
                      ) {
                        totalSums[j] +=
                          responseData[i][
                            this.colSelectedFieldsForTable[j].colField
                          ];
                      }
                    } else {
                      if (i === 0) {
                        totalSums.push("");
                      }
                    }
                  }
                }
              }

              data.push([]);
              data.push(headers);

              data.push([]);
              for (let i = 0; i < responseData.length; i++) {
                let row = [];
                for (
                  let j = 0;
                  j < this.colSelectedFieldsForTable.length;
                  j++
                ) {
                  row.push(
                    this.getToShow(
                      responseData[i][
                        this.colSelectedFieldsForTable[j].colField
                      ],
                      this.colSelectedFieldsForTable[j]
                    )
                  );
                }
                data.push(row);
              }

              let row = [];
              for (let i = 0; i < totalSums.length; i++) {
                row.push(
                  this.getToShow(
                    totalSums[i],
                    this.colSelectedFieldsForTable[i]
                  )
                );
              }
              data.push(row);

              excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: this.thisReport.reportName + "-" + date,
                autoWidth: true,
                bookType: "xlsx"
              });
            }

            this.makingExport = false;
          })
          .catch(err => {
            this.makingExport = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting enquiries for exporting(0/1/100000/0/0/*)`,
              life: 5000
            });
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.greenBackground {
  background-color: #5c9434;
  width: 83px;
}

.defaultBackground {
  // background-color: #2494f4;
  background-color: #248cc4;
  width: 50px;
}
</style>
